"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RecoverDisconnectedTableNames", {
    enumerable: true,
    get: function() {
        return RecoverDisconnectedTableNames;
    }
});
const _common = require("@nestjs/common");
const _models = require("~/models");
const _globals = require("~/utils/globals");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _cache = /*#__PURE__*/ _interop_require_default(require("~/utils/cache"));
const _utils = require("~/utils");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const PARALLEL_LIMIT = +process.env.NC_ORDER_MIGRATION_PARALLEL_LIMIT || 10;
const renameTableSql = {
    mariadb: 'RENAME TABLE ?? TO ??',
    mysql2: 'RENAME TABLE ?? TO ??',
    mysql: 'RENAME TABLE ?? TO ??',
    pg: 'ALTER TABLE ?? RENAME TO ??',
    sqlite3: 'ALTER TABLE ?? RENAME TO ??'
};
const replaceQuestionMarkWithPlaceholderPg = (tableName)=>{
    let index = 0;
    return tableName.split('?').reduce((tn, token)=>{
        if (index > 0) {
            token = '$' + index.toString() + token;
        }
        tn += token;
        index++;
        return tn;
    }, '');
};
const checkIfTableNameExists = (basemodel, tableName, knex)=>{
    let knexSchema = knex.schema;
    if (basemodel.schema) {
        knexSchema = knexSchema.withSchema(basemodel.schema);
    }
    return knexSchema.withSchema(basemodel.schema).hasTable(tableName);
};
let RecoverDisconnectedTableNames = class RecoverDisconnectedTableNames {
    logExecutionTime(message, hrTime) {
        const [seconds, nanoseconds] = process.hrtime(hrTime);
        // reset hrTime
        hrTime = process.hrtime();
        const elapsedSeconds = seconds + nanoseconds / 1e9;
        this.log(`${message} in ${elapsedSeconds}s`);
    }
    getModelsToBeProcessedQueryBuilder(ncMeta) {
        return ncMeta.knexConnection(_globals.MetaTable.MODELS).join(_globals.MetaTable.SOURCES, `${_globals.MetaTable.MODELS}.source_id`, '=', `${_globals.MetaTable.SOURCES}.id`).where(`${_globals.MetaTable.MODELS}.mm`, false).where((builder)=>{
            builder.where(`${_globals.MetaTable.SOURCES}.is_meta`, true);
            builder.orWhere({
                is_local: true
            });
        }).where((builder)=>{
            builder.where(`${_globals.MetaTable.MODELS}.table_name`, 'like', '%?%').orWhere(`${_globals.MetaTable.MODELS}.table_name`, 'like', '%$%');
        });
    }
    async job() {
        const ncMeta = _Noco.default.ncMeta;
        try {
            var _this;
            this.cache.clear();
            const totalHrTime = process.hrtime();
            const numberOfModelsToBeProcessed = +((_this = await this.getModelsToBeProcessedQueryBuilder(ncMeta).count('*', {
                as: 'count'
            }).first()) == null ? void 0 : _this.count);
            this.log(`Total models to be processed: ${numberOfModelsToBeProcessed}`);
            // eslint-disable-next-line no-constant-condition
            while(true){
                const modelToProcessQb = this.getModelsToBeProcessedQueryBuilder(ncMeta).select([
                    `${_globals.MetaTable.MODELS}.id`,
                    `${_globals.MetaTable.MODELS}.source_id`,
                    `${_globals.MetaTable.MODELS}.table_name`,
                    `${_globals.MetaTable.MODELS}.base_id`,
                    ..._utils.isEE ? [
                        `${_globals.MetaTable.MODELS}.fk_workspace_id`
                    ] : []
                ]).whereNotIn(`${_globals.MetaTable.MODELS}.id`, this.processingModels.map((m)=>m.fk_model_id)).orderBy(`${_globals.MetaTable.MODELS}.id`, 'asc').limit(PARALLEL_LIMIT * 2);
                const modelsToProcess = await modelToProcessQb;
                if (!(modelsToProcess == null ? void 0 : modelsToProcess.length)) break;
                for (const model of modelsToProcess){
                    this.processingModels.push({
                        fk_model_id: model.id,
                        processing: true
                    });
                    try {
                        await this.processModel(model, ncMeta);
                    } catch (ex) {
                        this.log(`Error processing model ${model.id}:`, ex.message);
                    }
                }
                await new Promise((resolve)=>setTimeout(resolve, 1000));
            }
            this.log(`Migration completed. Processed ${this.processedModelsCount} models`);
            this.logExecutionTime('Migration job completed', totalHrTime);
            return true;
        } catch (error) {
            this.log('Migration failed:');
            return false;
        }
    }
    async processModel(modelData, ncMeta) {
        try {
            const context = {
                base_id: modelData.base_id,
                workspace_id: modelData.fk_workspace_id
            };
            const source = await this.cache.get(modelData.source_id, async ()=>_models.Source.get(context, modelData.source_id));
            if (!source.isMeta()) {
                this.log(`Model ${modelData.id}:`, 'is not meta, skipping');
                return;
            }
            const dbDriver = await _NcConnectionMgrv2.default.get(source);
            const model = await _models.Model.get(context, modelData.id);
            const baseModel = await _models.Model.getBaseModelSQL(context, {
                model,
                source,
                dbDriver
            });
            let tableName = baseModel.getTnPath(model.table_name);
            if ([
                'pg',
                'postgres'
            ].includes(source.type)) {
                tableName = replaceQuestionMarkWithPlaceholderPg(tableName);
            }
            // replacing table name must not use tn name (without schema)
            let replacingTableName = model.table_name;
            if ([
                'pg',
                'postgres'
            ].includes(source.type)) {
                for(let i = 1; i <= 15; i++){
                    replacingTableName = replacingTableName.replaceAll('$' + i.toString(), '_');
                }
            }
            let counter = 1;
            replacingTableName = replacingTableName.replace(/[?$]/g, '_');
            const initialTableName = replacingTableName;
            while(await checkIfTableNameExists(baseModel, replacingTableName, dbDriver)){
                const oldReplacingTableName = replacingTableName;
                replacingTableName = `${initialTableName}_${counter}`;
                counter++;
                this.log('Table ' + oldReplacingTableName + ' exists, replacing with ' + replacingTableName);
            }
            this.log('Renaming table ' + tableName + ' to ' + replacingTableName);
            await dbDriver.raw(renameTableSql[source.type], [
                tableName,
                replacingTableName
            ]);
            await ncMeta.metaUpdate(modelData.fk_workspace_id, modelData.base_id, _globals.MetaTable.MODELS, {
                table_name: replacingTableName
            }, modelData.id);
            this.processedModelsCount++;
        } catch (error) {
            this.log(`Error processing model ${modelData.id}:`, error.message);
            throw error;
        }
    }
    constructor(){
        this.processingModels = [
            {
                fk_model_id: 'placeholder',
                processing: true
            }
        ];
        this.processedModelsCount = 0;
        this.cache = new _cache.default(1000);
        this.log = (...msgs)=>{
            console.log('[nc_job_008_recover_disconnected_table_name]: ', ...msgs);
        };
    }
};
RecoverDisconnectedTableNames = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [])
], RecoverDisconnectedTableNames);
